import { RootState } from './store';
import { BoatDetails, BoatGroup, HandicapSystem } from '../features/boatList/BoatDetails';
import { v4 as uuidv4 } from 'uuid';

export function cutover(result: RootState): RootState {
  console.log('Cutover from', result);
  result = cutoverSingleBoatList(result);
  result = cutoverStringHandicaps(result);
  return result;
}

function cutoverSingleBoatList(result: RootState): RootState {
  if (result.boatList.boatDetailsList && result.boatList.boatDetailsList.length > 0) {
    console.log('cutover moving root boat list to default group');
    // If the group list is undefined then create an empty one
    if (!result.boatList.boatGroupList) {
      result.boatList.boatGroupList = [];
    }
    // Create a new group to contain the exisiting boat list
    const newGroup = {
      id: uuidv4(),
      name: 'Default',
      handicapSystem: HandicapSystem.PY,
      baseBoatId: result.boatList.baseBoatId,
      boatDetails: result.boatList.boatDetailsList,
    };
    // Add it to the list
    result.boatList.boatGroupList.push(newGroup);
    // Make it the default
    result.boatList.currentGroupId = newGroup.id;
    // Remove the original one
    result.boatList.boatDetailsList = [];
    result.boatList.baseBoatId = '';
  }
  return result;
}

function cutoverStringHandicapsByBoat(boat: BoatDetails): void {
  if (boat.handicap && typeof boat.handicap == 'string') {
    console.log('cutover Converting handicap from string to number', boat);
    boat.handicap = Number(boat.handicap);
    console.log('cutover After Converting handicap from string to number', boat);
  }
}

function cutoverStringHandicapsByGroup(group: BoatGroup): void {
  group.boatDetails.forEach(cutoverStringHandicapsByBoat);
}

function cutoverStringHandicaps(result: RootState): RootState {
  result.boatList.boatGroupList.forEach(cutoverStringHandicapsByGroup);
  return result;
}
